var _circle, _rect, _rect2, _path, _path2, _path3, _g, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_26539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3526,
    cy: 21.784,
    r: 21.7841,
    transform: "rotate(180 22.3526 21.784)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_26539)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.568359,
    width: 43.5682,
    height: 43.5682,
    fill: "#A00009"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1367,
    y: 10.8921,
    width: 21.7841,
    height: 43.5682,
    transform: "rotate(90 44.1367 10.8921)",
    fill: "#F1B434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.244 11.9006H15.4542V12.7074L16.6644 12.7074V13.9177H15.4542V15.0483C15.8102 14.8424 16.2235 14.7245 16.6644 14.7245C18.0012 14.7245 19.0849 15.8082 19.0849 17.1449C19.0849 17.8618 18.7732 18.5059 18.278 18.9491V19.9688H11.4201V18.949C10.9249 18.5058 10.6133 17.8618 10.6133 17.1449C10.6133 15.8082 11.697 14.7245 13.0337 14.7245C13.4746 14.7245 13.8879 14.8424 14.244 15.0483V13.9177H13.0337V12.7074L14.244 12.7074V11.9006ZM14.8491 15.5439L14.8379 15.5313H14.8603L14.8491 15.5439ZM14.8379 18.7586L14.8491 18.746L14.8603 18.7586H14.8379Z",
    fill: "#E26E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40234 19.9688L20.2944 19.9687L20.2944 25.9121C20.2944 28.3044 18.8423 30.4573 16.6241 31.3535C15.485 31.8138 14.2117 31.8138 13.0726 31.3535C10.8545 30.4573 9.40234 28.3044 9.40234 25.9121L9.40234 19.9688Z",
    fill: "#F5F7F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3445_26539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 12,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40234 19.9688H20.2944V25.9121C20.2944 28.3044 18.8423 30.4573 16.6241 31.3535C15.485 31.8138 14.2117 31.8138 13.0726 31.3535C10.8545 30.4573 9.40234 28.3044 9.40234 25.9121V19.9688Z",
    fill: "#F5F7F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3445_26539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.40234,
    y: 19.9688,
    width: 5.44602,
    height: 6.05114,
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.40234,
    y: 26.0198,
    width: 5.44602,
    height: 6.05114,
    fill: "#E26E00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8496,
    y: 26.0198,
    width: 5.44602,
    height: 6.05114,
    fill: "#DD2033"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5047 19.9688H23.3201V31.4659H21.5047V19.9688Z",
    fill: "#F5F7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37695 19.9688H8.19229V31.4659H6.37695V19.9688Z",
    fill: "#F5F7F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsSpain);
export default __webpack_public_path__ + "static/media/ES Spain.7d705b974ffcb9b00deacac4c309cf16.svg";
export { ForwardRef as ReactComponent };